import styled from 'styled-components';

const Input = styled.input`
  min-width: 25px;
  padding: 5px 10px;
  ${(p) => p.theme.tableInputBorder}
`;

export default Input;
